import { faEye } from "@fortawesome/pro-regular-svg-icons/faEye";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC } from "react";

export const Eye: FC<JSX.IntrinsicAttributes> = (props) => {
  return <FontAwesomeIcon icon={faEye} {...props} />;
};
